<div
    class="sh-file-input-container box-border"
    [class.h-full]="fullHeight()"
    data-testid="details-attachments-container"
>
    <!-- Hidden file input -->
    <input
        #fileInput
        data-testid="global-attachments-input-file"
        type="file"
        [accept]="acceptedFileTypes()"
        [multiple]="multiple()"
        [disabled]="isDisabledInternal()"
        (change)="onFileSelected($event)"
        style="display: none"
    />

    <!-- Drag and drop area (shown when no files at all) -->
    @if (files.length === 0 && serverFiles().length === 0) {
        <sh-empty-state
            drag-and-drop
            icon="upload"
            [header]="'common.file-upload.drag-files-here' | translate"
            [label]="'common.file-upload.file-character-limit' | translate"
            [class.drag-over]="isDragOver"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            class="h-[250px] m-0 bg-shui-base-3 border border-dashed border-shui-base-5 rounded-md"
            [class.h-full]="fullHeight()"
        >
            <sh-button
                slot="footer"
                size="max-content"
                color="tertiary"
                [label]="'common.file-upload.choose-file' | translate"
                [disabled]="isDisabledInternal()"
                (click)="fileInput.click()"
            ></sh-button>
        </sh-empty-state>
    }

    <!-- File list table (shown when files exist) -->
    @if (files.length > 0 || serverFiles().length > 0) {
        <div class="file-list-container">
            <ul class="m-0 p-0 list-none flex flex-col">
                <!-- Server-side (already uploaded) files -->
                @for (s3File of serverFiles(); track s3File.Key) {
                    @let fileName = getServerFileName(s3File.Key);
                    <li
                        class="flex items-center gap-3 py-2 border-b border-shui-base-5 last:border-b-0"
                        data-testid="details-attachments-container-file"
                    >
                        <sh-icon
                            class="shrink-0 text-shui-text-subtle pointer-events-none"
                            size="s"
                            [icon]="getFileIcon(fileName)"
                        ></sh-icon>
                        <span class="flex-1 min-w-0 truncate text-sm text-shui-text-strong" [title]="fileName">
                            {{ fileName }}
                        </span>
                        <div class="flex shrink-0 items-center gap-3">
                            <sh-icon
                                button
                                icon="download"
                                size="s"
                                [title]="'common.general.download' | translate"
                                (click)="onDownloadServerFile($event, s3File.Key)"
                            ></sh-icon>
                            @if (!isDisabledInternal()) {
                                <sh-icon
                                    button
                                    icon="delete"
                                    size="s"
                                    [title]="'common.general.remove' | translate"
                                    (click)="onDeleteServerFile($event, s3File.Key)"
                                ></sh-icon>
                            }
                        </div>
                    </li>
                }

                <!-- Locally selected (pending upload) files -->
                @for (fileItem of files; track $index; let i = $index) {
                    <li
                        class="flex items-center gap-3 py-2 border-b border-shui-base-5 last:border-b-0"
                        [attr.data-testid]="'global-attachments-container-' + fileItem.file.name"
                    >
                        <sh-icon
                            class="shrink-0 text-shui-text-subtle pointer-events-none"
                            size="s"
                            [icon]="getFileIcon(fileItem.file.name)"
                        ></sh-icon>
                        <div class="flex flex-1 min-w-0 flex-col">
                            <span
                                class="truncate text-sm"
                                [class.text-shui-text-subtle]="fileItem.status === 'pending'"
                                [class.text-shui-text-strong]="fileItem.status !== 'pending'"
                                [title]="fileItem.file.name"
                            >
                                {{ fileItem.file.name }}
                            </span>
                            @if (fileItem.errorMessage) {
                                <span class="text-xs text-shui-text-subtle">
                                    {{ fileItem.errorMessage | translate }}
                                </span>
                            }
                        </div>
                        <sh-icon
                            class="shrink-0"
                            button
                            icon="cancel"
                            size="s"
                            [title]="'common.general.remove' | translate"
                            [class.disabled]="isDisabledInternal()"
                            (click)="onRemoveClick($event, i)"
                        ></sh-icon>
                    </li>
                }
            </ul>

            <!-- Browse button below table -->
            @if (multiple() && !isDisabledInternal()) {
                <div class="browse-button-container mt-2">
                    <sh-button
                        size="max-content"
                        [label]="'common.file-upload.choose-file' | translate"
                        [disabled]="isDisabledInternal()"
                        (click)="fileInput.click()"
                    ></sh-button>
                </div>
            }
        </div>
    }
</div>
